import { BrandIcon, type BrandIconName } from '@ria-client/tw-shared-ui';
import type { NodeProps } from '../types';
import { ContentLink } from './lib/content-link';

export type ContentRibbonProps = NodeProps<{
  title: string;
  icon?: BrandIconName;
  description?: string;
  href?: string;
  linkText?: string;
  headingLevel: 2 | 3;
}>;

export function ContentRibbon({ props }: ContentRibbonProps) {
  const { title, icon, description, href, linkText, headingLevel = 3 } = props;
  const Heading = `h${headingLevel}` as 'h2' | 'h3';

  return (
    <div className="flex flex-col bg-[var(--content-yellow-lightest)] p-2">
      <div className="flex items-center gap-2">
        {icon ? <BrandIcon name={icon} size={30} /> : null}
        <Heading className="typography-h3">{title}</Heading>
      </div>
      <div className={icon ? 'flex flex-col md:ml-[46px]' : 'flex flex-col'}>
        {description ? <p className="typography-body mt-1">{description}</p> : null}
        {href ? (
          <div className="typography-text-small mt-1 font-medium">
            {'» MORE: '}
            <ContentLink
              className="text-secondary-foreground no-underline hover:underline"
              href={href}
            >
              <span className="typography-text">{linkText}</span>
            </ContentLink>
          </div>
        ) : null}
      </div>
    </div>
  );
}
